import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as _ from "lodash";
import {Application} from "../application";
import * as ko from "knockout";
import {ActivePanel} from "../state/activePanel";

export class RemoveEstimateRowCommand implements Command {
    constructor(private app: Application) {
    }

    type: CommandType = CommandType.RemoveEstimateRow;
    canExecute = ko.computed(() => {

        if(this.app.state.activePanel() != ActivePanel.Estimate)
            return false;
        
        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        if (estimate.selectedRow().length == 0 && !estimate.clickedTextRow())
            return false;


        let row = estimate.selectedRow()[0];

        if (row)
            return row.removable;
        
        return !!estimate.clickedTextRow();
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let estimate = this.app.state.estimate();
        
        let idx = _.map(estimate!.selectedRow(), (x) => x.id);
        if (idx.length == 0 && !!estimate!.clickedTextRow())
            idx.push(estimate!.clickedTextRow()!.id);

        console.log("removing", estimate!.selectedRow());

        return this.app.apiManager.estimateRows.remove({estimateId: estimate!.id(), idx: idx}).then((data) => {
            
            this.app.state.canUndo(data!.canUndo);
            this.app.state.canRedo(data!.canRedo);

            estimate!.clickedTextRow(undefined);
            estimate!.focusedRowOrder(undefined);
            estimate!.selectedRow([]);
            estimate!.timestamp(new Date());

            console.log("removed", data);
        });

    }

    name = "Remove Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/removeEstimateRowCommand.ts